import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Container from "@mui/material/Container";
import intl from "react-intl-universal";
import { Form, json, Link, useLoaderData, useNavigate } from "react-router-dom";
import Copyright from "../components/Copyright";
import { Routes } from "../Routes";
import { Alert, Typography } from "@mui/material";
import CreatePasswordInput from "../components/CreatePasswordInput";
import { useState } from "react";
import UserService from "../services/UserService";
import MaskedTextField from "../components/MaskedTextField";
import Validate from "../utils/Validate";

export async function SignUpLoader ({ params }) {
  const data = { companyName: params.companyName };
  return json(data, { status: 200 });
}


export default function SignUp() {
  const data = useLoaderData();	
  const navigate = useNavigate();
  
  const [isPasswordValid, setIsPasswordValid] = useState(false); 
  const [errorMessage, setErrorMessage] = useState("");



  function handlePasswordChange(_newPassword, isPasswordValid) {
    setIsPasswordValid(isPasswordValid);
    setErrorMessage("");
  };
  


  async function handleSubmit (event){
    event.preventDefault();
    if (!isPasswordValid) {
      setErrorMessage( intl.get("passworddoesnotmeetrequirements").d("Password does not meet requirements.") );
      return;
    }

    const formData = new FormData(event.currentTarget);
    const stateData = Object.fromEntries(formData.entries());
  
    
    if (!Validate.email(stateData.email)) {
      setErrorMessage(intl.get("invalidemailformat").d("Invalid email format.") );
      return;
    }
    
    if (!Validate.phone(stateData.phone)) {
      setErrorMessage(intl.get("invalidphone").d("Invalid phone.") );
      return;
    }
    
    const emailExist = await UserService.emailExists(stateData.email);
    if( emailExist === undefined || !emailExist.ok ){
 	  setErrorMessage(intl.get("erroroccurredvalidatingemail").d("Error occurred validating email.") );
      return;			
	}
	
    if( emailExist.exists  === true ){
 	  setErrorMessage(intl.get("emailalreadyregistered").d("This email is already registered.") );
      return;			
	}
    
    const phoneExist = await UserService.phoneExists(stateData.phone);
    if( phoneExist === undefined || !phoneExist.ok){
 	  setErrorMessage(intl.get("erroroccurredvalidatingphone").d("Error occurred validating phone.") );
      return;			
	}
	
    if( phoneExist.exists === true ){
 	  setErrorMessage(intl.get("phonealreadyregistered").d("This phone number is already registered.") );
      return;		
	}
    
    setErrorMessage("");


   // tell otp the next page
   stateData.nextPath = Routes.createAccount;

    // send to OTP page
    navigate(Routes.sendOtp, { state: stateData });
  };


  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
          <PersonAdd />
        </Avatar>
        
        <Typography component="h1" variant="h5">
          {intl.get("signup").d("Sign Up")}
        </Typography>

        <Box sx={{ mt: 1 }}>
          <Form method="post" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  name="email"
                  label={intl.get("emailaddress").d("Email address")}
                  autoComplete="email"
                  autoFocus
                />
              </Grid>

              <Grid item xs={12}>
                <MaskedTextField
                  mask="(999) 999-9999"
                  alwaysShowMask={false}
                  required
                  fullWidth
                  id="phone"
                  name="phone"
                  label={intl.get("mobilephone").d("Mobile phone")}
                  autoComplete="tel-national"
                />
              </Grid>
                            
              <Grid item xs={12}>
                <CreatePasswordInput
                  required
                  fullWidth
                  id="password"
                  name="password"
                  label={intl.get("password").d("Password")}
                  autoComplete="new-password"
                  defaultValue=""
                  onPasswordChange={handlePasswordChange}
                />
              </Grid>
              
              <Grid item xs={12} style={{ paddingTop: '1px' }}>
				  <div hidden={!!data.companyName}>
				    <TextField
				      readOnly={!!data.companyName}
				      margin="normal"
				      required
				      fullWidth
				      name="companyName"
				      id="companyName"
				      label={intl.get('company').d('Company')}
				      type={data.companyName ? 'hidden' : 'text'}
				      defaultValue={data.companyName ? data.companyName : ''}
				    />	 
				  </div>  	         
			  </Grid>

              {errorMessage && (
                <Grid item xs={12}>
                  <Alert severity="error">{errorMessage}</Alert>
                </Grid>
              )}   
                      
            </Grid>    

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              {intl.get("continue").d("Continue")}
            </Button>
            
            <div hidden>
              <TextField
                readOnly
                margin="normal"
                required
                fullWidth
                name="isClient"
                id="isClient"
                type="hidden"
                value={true}
              />	      
            </div> 
            
          </Form>
          <Grid container justifyContent="flex-end">
            <Grid item>
			  <Link
				  to={data?.companyName ? `${Routes.signIn}/${data.companyName}` : Routes.signIn}
				  variant="body2"
			  >
                {intl
                  .get("alreadyhaveanaccountsignin")
                  .d("Already have an account? Sign in.")}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Copyright sx={{ mt: 5 }} />
    </Container>
  );
}
